// eslint-disable-next-line import/no-extraneous-dependencies
import ReactPlayer from "react-player/lazy";
import { MediaPlayerProps } from "typing";

const ReactVideoPlayer = ({ ...playerProps }: MediaPlayerProps) => {
  return <ReactPlayer width="100%" height="100%" {...playerProps} />;
};

export { ReactVideoPlayer };
